import React, { useState } from "react";
import { Button, Box, Typography, Stack, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ModalV2 from "./ModalV2";
import Checkbox from "@mui/material/Checkbox";
import { MagnifyingGlass, UserCircle } from "@phosphor-icons/react";
import { useGlobalToast } from "../components/GlobalToastProvider";

const ItemControlPanel = ({
  classes,
  items = [],
  setItems = () => {},
  renderItem = null,
  buttonIcon = <AddIcon />,
  listItemIcon = <UserCircle />,
  buttonText = "Add Item",
  titleSubmitDialog,
  onSubmitDialog,
  isSubmittingDialog,
  titleDialog,
  onCancelDialog,
  onSearch,
  filteredItems,
  onCheckboxSelected,
  descriptionDialog,
  searchInputPlaceHolder,
  addNewButtonText,
  addNewFormFields,
  onAddNewSubmit,
  isAddNewValid,
  isSubmittingAddNew,
  isSubmitDisabled = false,
}) => {
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState("list");
  const { showToast } = useGlobalToast();

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    onSearch("");
    setMode("list");
    setOpen(false);
  };

  const handleRemove = (index) => {
    setItems((prevItems) => prevItems.filter((_, i) => i !== index));
  };

  const isAddNewMode = mode === "create";

  return (
    <Box>
      {items.length > 0 && (
        <Box sx={{ marginTop: "16px", gap: 2, display: "flex", flexDirection: "column" }}>
          {items?.map((item, index) => {
            const isOnlyItem = items.length === 1;
            return renderItem
              ? React.cloneElement(renderItem(item, isOnlyItem), {
                  key: index,
                  onRemove: () => handleRemove(index),
                })
              : null;
          })}
        </Box>
      )}
      <Button
        color="secondary"
        variant="contained"
        startIcon={buttonIcon}
        onClick={handleOpen}
        fullWidth
        sx={{ marginTop: "16px" }}
      >
        {buttonText}
      </Button>
      <ModalV2
        open={open}
        titleDialog={isAddNewMode ? addNewButtonText : titleDialog}
        onCancelDialog={onCancelDialog}
        maxWidth="xs"
        cancelActionText={isAddNewMode ? "Back" : "Cancel"}
        cancelOnClick={isAddNewMode ? () => setMode("list") : handleClose}
        onCloseDialog={handleClose}
        actionText={isAddNewMode ? "Create & Connect" : titleSubmitDialog}
        actionOnClick={async () => {
          try {
            if (isAddNewMode) {
              await onAddNewSubmit();
            } else {
              await onSubmitDialog();
            }
            handleClose();
          } catch {
            // keep the dialog open so the user can retry
            showToast({
              message: isAddNewMode
                ? "Failed to create and connect the new item. Please try again."
                : "Failed to connect the selected item. Please try again.",
              errorState: true,
            });
          }
        }}
        actionDisabled={isAddNewMode ? !isAddNewValid : isSubmitDisabled}
        isSubmittingDialog={isAddNewMode ? isSubmittingAddNew : isSubmittingDialog}
        actions={
          !isAddNewMode && addNewButtonText ? (
            <Button onClick={() => setMode("create")} variant="text" color="primary">
              {addNewButtonText}
            </Button>
          ) : null
        }
      >
        {isAddNewMode ? (
          <Box display="flex" flexDirection="column" gap={3} paddingTop={"24px"} width={"100%"}>
            {addNewFormFields?.map((field) => <Box key={field.id}>{field.input}</Box>)}
          </Box>
        ) : (
          <Box display="flex" flexDirection="column" gap={5} paddingTop={"24px"} width={"100%"}>
            <Typography variant="body2">{descriptionDialog}</Typography>
            <TextField
              onChange={(event) => {
                onSearch(event.target.value);
              }}
              placeholder={searchInputPlaceHolder}
              classes={{
                root: classes.searchBar,
              }}
              sx={{ height: 38 }}
              InputProps={{
                startAdornment: (
                  <MagnifyingGlass size={20} weight="regular" color="rgba(0, 0, 0, 0.56)" />
                ),
              }}
            />
            <Stack direction="column" spacing={2} width="100%" sx={{ maxHeight: "340px" }}>
              {filteredItems?.map((clinic) => (
                <Stack
                  key={clinic.id}
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  spacing={2}
                  sx={{
                    paddingY: "8px",
                    backgroundColor: "#fff",
                  }}
                >
                  <Stack direction="row" alignItems="center" spacing={2}>
                    {listItemIcon}
                    <Typography variant="body2">{clinic.name}</Typography>
                  </Stack>
                  <Checkbox
                    onChange={() => {
                      onCheckboxSelected(clinic.id);
                    }}
                  />
                </Stack>
              ))}
            </Stack>
          </Box>
        )}
      </ModalV2>
    </Box>
  );
};

export default ItemControlPanel;
